import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=75baa3ee&"
import script from "./NewList.vue?vue&type=script&lang=js&"
export * from "./NewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75baa3ee')) {
      api.createRecord('75baa3ee', component.options)
    } else {
      api.reload('75baa3ee', component.options)
    }
    module.hot.accept("./NewList.vue?vue&type=template&id=75baa3ee&", function () {
      api.rerender('75baa3ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warehouse/orders/transfer/NewList.vue"
export default component.exports